import * as layout from '../../../../components/markLayout.module.css';
import React from 'react';
import SegmentPicker from '../../../Segments/SegmentPicker';
import type { PickedSegment } from '../../../Segments/SegmentPicker';
import DurationInput from '../DurationInput';
import RefPicker from '../RefPicker';
import ExitReasonSelect from '../ExitReasonSelect';
import type {
    CheckSegmentStep,
    DripStep,
    AuthorableDripExitReason,
    SegmentTargetKind
} from '../../../../types';
type Props = {
    step: CheckSegmentStep;
    allSteps: DripStep[];
    onChange: (patch: Partial<CheckSegmentStep>) => void;
    dripTargetKind?: string;
};
const VALID_TARGET_KINDS = new Set<string>([
    'PROFILE',
    'MEMBERSHIP',
    'MEMBERSHIP_ADMIN',
    'PROSPECT'
]);
const CheckSegmentForm: React.FC<Props> = ({ step, allSteps, onChange, dripTargetKind }) => {
    const filterTargetKinds =
        dripTargetKind && VALID_TARGET_KINDS.has(dripTargetKind)
            ? dripTargetKind === 'PROFILE'
                ? ['PROFILE' as SegmentTargetKind]
                : ['PROFILE' as SegmentTargetKind, dripTargetKind as SegmentTargetKind]
            : undefined;
    const handleSegmentChange = (picked: PickedSegment | null) => {
        onChange({ segment_id: picked?.segment_id });
    };
    const hasSelfLoopCondition = step.wait_for != null;
    const showExitReason = step.on_true === 'exit' || step.on_false === 'exit';
    return (
        <div className={layout.form}>
            <SegmentPicker
                value={step.segment_id ?? null}
                onChange={handleSegmentChange}
                filterTargetKinds={filterTargetKinds}
            />
            <div>
                <span
                    style={{
                        fontWeight: 600,
                        display: 'block',
                        marginBottom: '0.4rem'
                    }}
                >
                    Wait duration
                </span>
                <DurationInput value={step.wait_for} onChange={(v) => onChange({ wait_for: v })} />
            </div>
            <RefPicker
                label="On true"
                value={step.on_true}
                onChange={(v) => onChange({ on_true: v })}
                steps={allSteps}
                currentStepId={step.id}
                allowSelfLoop={hasSelfLoopCondition}
            />
            <RefPicker
                label="On false"
                value={step.on_false}
                onChange={(v) => onChange({ on_false: v })}
                steps={allSteps}
                currentStepId={step.id}
                allowSelfLoop={hasSelfLoopCondition}
            />
            {showExitReason && (
                <ExitReasonSelect
                    value={step.exit_reason as AuthorableDripExitReason | undefined}
                    onChange={(v) => onChange({ exit_reason: v })}
                />
            )}
        </div>
    );
};
export default CheckSegmentForm;
